export const VALIDATION_MESSAGE = "Hatalı veri girişi";
export const ENTITY_IS_IN_USE_MESSAGE = "Bu kayıt kullanımda";
export const EXCEL_VALIDATION_MESSAGE = "Kullanılan excel dosyasında veri eksiği bulunmakta";

export const PRODUCT_TYPES = ["FABRIC", "PADDED_FABRIC", "FIBER"]
export const CURRENCIES = ["TRY", "USD", "EUR"]

export const PAYMENT_METHODS = ["CASH", "CREDIT_CARD", "BANK_TRANSFER", "CHEQUE"]

export const USER_ROLES = ["MANAGER", "ADMIN", "SALES", "DEPOT"]

